export const navigation = [
  {
    id: 'home',
    text: 'Home',
    path: '/home',
    icon: 'home',
    order: 0
  },
  {
    id: 'my-conversations',
    text: 'My Conversations',
    icon: 'message',
    items: [],
    order: 1,
    disabled: true
  },
  {
    id: 'my-gpts',
    text: 'My GPTs',
    icon: 'toolbox',
    items: [],
    order: 2,
    disabled: false,
    path: '/my-gpts'
  },
  {
    id: 'settings',
    text: 'Settings',
    icon: 'preferences',
    items: [
      {
        id: 'my-profile',
        text: 'My Profile',
        path: '/profile',
        icon: 'user',
        order: 0
      },
      {
        id: 'outlook-addin',
        text: 'Outlook Add-in',
        path: '/outlook-addin',
        icon: 'mail',
        order: 1
      },
      {
        id: 'administration',
        text: 'Administration',
        path: '/tasks',
        icon: 'card',
        order: 2,
        visible: false
      }
    ],
    order: 3
  }
];
